<template>
  <svg
    width="142"
    height="142"
    viewBox="0 0 142 142"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="71" cy="71" r="68.5" stroke="#0071BC" stroke-width="5" />
    <rect
      x="28"
      y="43"
      width="86"
      height="56"
      rx="4"
      stroke="#0071BC"
      stroke-width="4"
    />
    <path
      d="M71.578 72.1397C71.2317 72.385 70.7683 72.385 70.422 72.1397L31.8474 44.816C31.0519 44.2525 31.4506 43 32.4254 43L109.575 43C110.549 43 110.948 44.2525 110.153 44.816L71.578 72.1397Z"
      stroke="#0071BC"
      stroke-width="4"
    />
  </svg>
</template>
